/**
 * @file Orgs that have been migrated to the new dashboard (Remidio Connect v2).
 * Members of these orgs are shown an upgrade interstitial on every protected
 * route and redirected to v2 instead of using this (v1) dashboard.
 *
 * Ids are the backend organizationId values, stored as strings because
 * sessionStorage only holds strings. The orgId is written to sessionStorage
 * at login (LoginPassword.js / Loginusername.js) — sessions that predate that
 * change simply don't match and keep using v1 until their next login.
 */

export const V2_DASHBOARD_URL = "https://dashboard.remidio.ai/";

export const V2_MIGRATED_ORG_IDS = [
  // Dr Shroff Charity Eye Hospital (India) — v2 pilot, Aug 2026
  "6239012964532224"
];

/**
 * Whether the currently signed-in session belongs to a v2-migrated org.
 * @returns {boolean}
 */
export const isMigratedToV2 = () => {
  const orgId = sessionStorage.getItem("orgId");
  return Boolean(orgId) && V2_MIGRATED_ORG_IDS.includes(orgId);
};
